export default __webpack_public_path__ + "static/media/3.ac130f7f.PNG";